import React, { useContext, useEffect, useState } from "react";
import { InputForm } from "../atoms/input";
import { Chip } from "./Chip";
import { HorizontalLayout, VerticalLayout } from "../components/layout";
import { IconButton, MagicButton } from "../atoms/buttons";
import { border, padding, position } from "polished";
import { SuggestedSkillsPanel } from "./SuggestAiSkill";
import { Alert } from "../components/alert";
import { ToastContext } from "../App";
import { TitleDescriptionText } from "../atoms/titleDescription";

export function Skills({suggestedSkills, loadSuggestions, loading , setLoading, setSkills, skills, onAddSkill, onRemoveSkill, inputPlaceholder = "Voeg skill toe...", disabled = false, id_module, id_lessons}) {
    const [newSkill, setNewSkill] = useState("");
    const [expandedPanel, setExpandedPanel] = useState(false);
    const [clickedToShowSuggestions, setClickedToShowSuggestions] = useState(false);
    const [collapsed, setCollapsed] = useState(true);
    const showToast = useContext(ToastContext)
    const addSkills = (newSkills) => {
      if (!Array.isArray(newSkills)) return;

      const existingSkills = skills;
      const mergedSkills = [...existingSkills];

      newSkills.forEach((newSkill) => {
        const exists = existingSkills.some((s) =>
          (newSkill.id_skill && s.id_skill === newSkill.id_skill) ||
          (!newSkill.id_skill && s.skill_name === newSkill.skill_name)
        );
        if (!exists) {
          mergedSkills.push(newSkill);
        }
      });

      setSkills(mergedSkills);
      if (onAddSkill) {
        onAddSkill(newSkills);
      }
      setNewSkill("");
    };

    const addSkill = () => {
      const trimmed = newSkill.trim();
      if (trimmed && !skills.some(s => s.skill_name === trimmed)) {
        addSkills([{ id_skill: null, skill_name: trimmed }]);
      }
    };

    const removeSkill = (skillToRemove) => {
        const updated = skills.filter((s) => s.skill_name !== skillToRemove.skill_name);
        setSkills(updated);
        onRemoveSkill && onRemoveSkill(skillToRemove);
    };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addSkill();
    }
  };

const handleSaveSuggestions = (selectedSkills) => {
  addSkills(selectedSkills);
  setExpandedPanel(false);
  setClickedToShowSuggestions(false);
};
  useEffect(() => {
      if (clickedToShowSuggestions && !loading) {
      setExpandedPanel(true);
    }
  }, [clickedToShowSuggestions, loading]);
  const handleCollapse = () => {
    if(loading){
      return showToast.showToast(<>Wacht tot de suggesties zijn geladen voordat je dit gedeelte kunt inklappen.</> , "info")
    }
    if (expandedPanel) {
      return showToast.showToast(<>Kies een skill voordat je dit gedeelte kunt inklappen.</> , "info")
    }
    setCollapsed(!collapsed);
  }
  return (
    <>
      <VerticalLayout className="phone-skill-comp" onClick={() => handleCollapse()} style={{ maxHeight: collapsed ? "3rem" : "10rem", overflow: "hidden", transition: "max-height 0.5s ease-in-out", backgroundColor: collapsed ? "var(--primary-50)" : "var(--card-background-color)", padding: "2rem" , }}>
            <HorizontalLayout className="space-between" style={{ gap: "1rem" }}>
                <TitleDescriptionText style={{ paddingBottom: "0", marginTop: "0", paddingTop: "0", margin: collapsed ? "0" : "" }} className={"avatar-title"} title={<span> Skills{" "} {collapsed && skills.length > 0 && ( <span style={{ color: "var(--standard-text-color-light)", fontSize: "0.9rem" }}> ({skills.length}) </span>)} </span>} description={collapsed ? "": "Voeg skill toe of genereer suggesties via AI op basis van de module."} />
              {!expandedPanel &&  <IconButton icon2={collapsed ? "chevron-down" : "chevron-up"} onClick={() => handleCollapse()} /> }
            </HorizontalLayout>
            { !collapsed &&
             ( <div className="skill-molecules">
                <div
                  className="skill-molecules__chips"
                  style={{
                    marginTop: "1rem",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.5rem"
                  }}
                >
                  {skills.map((skill) => (
                    <Chip
                      key={skill.id_skill}
                      label={skill.skill_name}
                      onClose={() => removeSkill(skill)}
                      variant="outlined"
                      size="medium"
                      className="skill-molecules__chip"
                    />
                  ))}
                  {skills.length < 10 && (<Chip
                    label=""
                    variant="default"
                    size="medium"
                    disabled={disabled || skills.length >= 10}
                    className="skill-molecules__chip"
                    input={
                      <InputForm
                        onBlur={addSkill}
                        style={{ margin: 0, border: 0, minWidth: "6rem" }}
                        placeholder={skills.length >= 10 ? "" : inputPlaceholder}
                        value={newSkill}
                        typeInput={setNewSkill}
                        disabled={disabled || skills.length >= 10}
                        action={addSkill}
                        onKeyDown={handleKeyDown}
                      />
                    }
                  />)}
                </div>
              </div>)}
              {skills.length >= 10 && suggestedSkills.length > 0 && expandedPanel && (<div style={{ marginTop: "auto", paddingTop: "1rem" }}>
                <Alert
                  type="warning"
                  message="Je kunt maximaal 10 skills toevoegen. Verwijder een skill om een nieuwe toe te voegen."
                />
              </div>)}
          </VerticalLayout>
       {expandedPanel && ( <VerticalLayout className={`ai-suggest-comp ${expandedPanel ? "expanded" : ""}`}>
           
            <div
              style={{
                height: "100%",
                width: "100%",
              }}
            >
              <SuggestedSkillsPanel
                suggestedSkills={suggestedSkills}
                handleAddSkills={handleSaveSuggestions}
                onClose={() => {
                  setExpandedPanel(false);
                  setClickedToShowSuggestions(false);
                }}
                loading={loading}
                currentSkillCount={skills.length}
              />
            </div>
        
        </VerticalLayout>  )}
        {!expandedPanel && !collapsed && (  
          <MagicButton
          style={{ border: "0", height: "unset", width: "unset", position: "absolute", bottom: "0" , right: "0", padding: "2rem"}}
          onClick={() => {
            loadSuggestions();
            setClickedToShowSuggestions(true);
          }}
          loading={loading}
         />
         )}
    </>
  );
}